<template>
  <main class="notfound">
    <div id="pTop">
      <h1>You're missing something!.</h1>
      <h2>What you're looking for, is not here.</h2>
    </div>
  </main>
</template>

<script>
export default {
  name: "notFound",
  title: "404 - Nethanzêl Showroom",
};
</script>

<style scoped lang="scss">
.notfound {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 80vh;
}

h1 {
  font-size: 75px;
  letter-spacing: 3px;
  cursor: default;
  transition: .4s;
}

h2 {
  font-size: 35px;
  letter-spacing: 2px;
  cursor: default;
  transition: .4s;
}

@media (prefers-color-scheme: dark) {
  h2, h1 {
    color: #fff;
  }
}

@media (prefers-color-scheme: light) {
  h2, h1 {
    color: #000;
  }
}

@media screen and (max-width: 660px) {
  h1 {
    font-size: 65px;
    letter-spacing: 3px;
  }

  h2 {
    font-size: 30px;
    letter-spacing: 2px;
  }
}

@media screen and (max-width: 570px) {
  h1 {
    font-size: 55px;
    letter-spacing: 3px;
  }

  h2 {
    font-size: 25px;
    letter-spacing: 2px;
  }
}

@media screen and (max-width: 490px) {
  h1 {
    font-size: 45px;
    letter-spacing: 3px;
  }

  h2 {
    font-size: 20px;
    letter-spacing: 2px;
  }
}
</style>
